'use client';
import React from 'react';

import { Link, useLocation } from 'react-router-dom';

import { routesConstants, iconConstants } from '@/constants';
import logo from '@/assets/Logo.png';

import IconWithTitle from '../iconWithTitle/IconWithTitle';
import Icons from '@/icons';

import styles from './sideDrawer.module.scss';

const SideDrawer = () => {
  const location = useLocation();

  return (
    <div className={styles.sideDrawer}>
      <Link to={routesConstants.ROUTES.HOME} className={styles.header}>
        <img src={logo} alt="logo" className={styles.logo} />
      </Link>

      <div className={styles.wrapper}>
        <div className={styles.content1}>
          <IconWithTitle
            title="Dashboard"
            icon={<Icons type={iconConstants.ICONS.DASHBOARD} />}
            url={routesConstants.ROUTES.HOME}
            isActive={location.pathname === routesConstants.ROUTES.HOME}
          />
          <IconWithTitle
            title="My Music"
            icon={<Icons type={iconConstants.ICONS.MUSIC} />}
            url={routesConstants.ROUTES.MY_MUSIC}
            isActive={location.pathname === routesConstants.ROUTES.MY_MUSIC}
          />
          <IconWithTitle
            title="Upload Music"
            icon={<Icons type={iconConstants.ICONS.UPLOAD} />}
            url={routesConstants.ROUTES.UPLOAD_MUSIC}
            isActive={location.pathname === routesConstants.ROUTES.UPLOAD_MUSIC}
          />
          <IconWithTitle
            title="Reports"
            icon={<Icons type={iconConstants.ICONS.REPORTS} />}
            url={routesConstants.ROUTES.REPORTS}
            isActive={location.pathname === routesConstants.ROUTES.REPORTS}
          />
          <IconWithTitle
            title="Financial"
            icon={<Icons type={iconConstants.ICONS.FINANCIAL} />}
            url={routesConstants.ROUTES.FINANCIAL}
            isActive={location.pathname === routesConstants.ROUTES.FINANCIAL}
          />
          <IconWithTitle
            title="Profile"
            icon={<Icons type={iconConstants.ICONS.PROFILE} />}
            url={routesConstants.ROUTES.PROFILE}
            isActive={location.pathname === routesConstants.ROUTES.PROFILE}
          />
        </div>
        <div className={styles.contractSupport}>
          <IconWithTitle
            title="Contract Support"
            icon={<Icons type={iconConstants.ICONS.CONTACT_SUPPORT} />}
            url={routesConstants.ROUTES.CONTACT_US}
            isActive={location.pathname === routesConstants.ROUTES.CONTACT_US}
          />
        </div>
      </div>
    </div>
  );
};

export default SideDrawer;
